export const campoMixin = {
  props: {
    label: {
      type: String,
      default: 'Label',
    },
    labelSup: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    id: {
      type: String,
      default: 'id',
    },
    somenteLeitura: {
      type: Boolean,
      default: false,
    },
    valor: {
      type: String,
      default: '',
    },
    validacao: {
      type: Object,
      default: () => {
        return {}
      },
    },
    exibeLabel: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      valorInterno: '',
    }
  },
  updated() {
    if (this.multiplo && this.checkbox) return

    if (this.valor && this.valor !== this.valorInterno) {
      this.atualizar(this.valor)
    }
  },
  methods: {
    atualizar(valor, valoresJaMarcado) {
      let val = ''

      if (this.multiplo && this.checkbox) {
        let valorInternoArray = []

        if (this.valorInterno) {
          valorInternoArray = this.valorInterno.split(',')
        } else if (valoresJaMarcado) {
          valorInternoArray = valoresJaMarcado.split(',')
        }

        const indexOf = valorInternoArray.indexOf(valor)

        if (~indexOf) {
          valorInternoArray.splice(indexOf, 1)
        } else {
          valorInternoArray.push(valor)
        }

        val = valorInternoArray.join()
      } else if (this.multiplo) {
        val = Object.values(valor.selectedOptions)
          .map((v) => v.value)
          .toString()
      } else if (typeof valor.value !== 'undefined') {
        val = valor.value
      } else {
        val = valor
      }

      this.valorInterno = val
      this.$emit('atualizar', val)

      if (typeof this.validacao.$touch !== 'undefined') {
        this.validacao.$touch()
      }
    },
  },
}
